import { useSetRecoilState } from "recoil";
import { orderAtom } from "../miscellaneous/orderAtom";

export function useSetOrderState() {
  return useSetRecoilState(orderAtom);
}
